import { createContext } from 'react'

export const SelectedAttachmentContext = createContext(null)
